import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Grid } from '@mui/material'

import { SingleOptionSelectorField, ModelMenuSelectorField, ModelAutocompleteField } from '@front/squirtle'

const Title = () =>
  <Grid size={12}>
    <Typography variant={'h5'}> {I18n.t('poi.search')} </Typography>
  </Grid>

const Row1 = () =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <ModelMenuSelectorField
        name='type'
        label={I18n.t('type.label', { count: 1 })}
        model_name='poitype'
        labelKeys={['name_translated']}
        searchMode={'search'}
        allowNone={false}
        config={{ initial_filter: {}, force_filter: { active: true } }}
      />
    </Grid>
    <Grid size="grow">
      <ModelAutocompleteField
        name={'poi_id'}
        label={I18n.t('name.label', { count: 1 })}
        model_name={'poi'}
        searchMode={'search'}
        searchQuery={'contains'}
        labelKeys={['name_trkey.fr']}
        autocompleteKey={'name_trkey.fr'}
        config={{ populate: ['name_trkey'] }}
        loadOnFocus={false}
      />
    </Grid>
    <Grid size={1}>
      <SingleOptionSelectorField name='active' label={I18n.t('active')} />
    </Grid>
  </Grid>

const SearchForm = () =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 />
    </Grid>
  </Box>

export default React.memo(SearchForm)
